import { lighten } from "polished";
import styled from "styled-components";

import { theme } from "../theme";
export const ScreenLayout = styled.main({
  position: "relative",
  minHeight: "100%",
  width: "100%",
});
export const ContentWrapper = styled("aside")(() => ({
  padding: "4.375rem 0  0 18.75rem",
  display: "flex",
  transition: "all .3s",
  minHeight: "100vh",
  backgroundColor: lighten(0.35, theme.colors.secondary.main),
  "&.navCollapse": { padding: "4.375rem 0  0 5rem" },
}));

export const ContentFullWrapper = styled(ContentWrapper)(() => ({
  padding: "5.625rem 1.25rem  ",
}));
